/**
 * Created by rxsl-101 on 2018/3/20.
 */
import { MsgBox, Vue } from '../../app.vues';
import { Utils } from '../../app.base';
//
import SwbMerchtAuditBpNodeList from './MerchtAuditBpNodeList.vue';

Vue.regist(SwbMerchtAuditBpNodeList);

import oaAuditApi from '../../api/oaAudit'

export function getMerchtAuditBpConfInfo(bizTypeCode, pullBackFlag, callbackFunc) {
    let filterItems = {};
    filterItems.bizTypeCode = bizTypeCode;
    filterItems.pullBackFlag = pullBackFlag;
    let theLoad = MsgBox.loading();
    oaAuditApi.getMerchtAuditBpConfInfo(filterItems, function (result) {
        theLoad.hide();
        if(result.type === 'info') {
            let merchtAuditBpConfInfo = result.data || {};
            callbackFunc(merchtAuditBpConfInfo);
        } else {
            MsgBox.warning(result.message);
        }
    });
}

export function openOaAuditBpNodeDlg(params, callbackFun, cancleFunc) {
    let bizTypeCode = params['bizTypeCode'] || null;
    let pullBackFlag = params['pullBackFlag'] == null ? null : Utils.isTrue(params['pullBackFlag']);
    let bizVoucherNo = params['bizVoucherNo'] || null;
    let auditSeqNo = params['auditSeqNo'];
    let theDlg = Vue.$showDialog({
        title: '选择OA审核人',
        width: 600,
        height: 700,
        showCloseBtn: true,
        template: '<swb-oa-audit-bp-node-list :bizTypeCode="bizTypeCode" :pullBackFlag="pullBackFlag" :bizVoucherNo="bizVoucherNo" :auditSeqNo="auditSeqNo" @other-close="closeDlg" ref="swb_oa_audit_bp_node_list"></swb-oa-audit-bp-node-list>',
        data: {
            bizTypeCode: bizTypeCode,
            pullBackFlag: pullBackFlag,
            bizVoucherNo: bizVoucherNo,
            auditSeqNo: auditSeqNo
        },
        methods: {
            closeDlg: function () {
                theDlg.close();
            }
        },
        okClicked: function () {
            let result = this.$refs.swb_oa_audit_bp_node_list.getDlgResult() || {};
            if(result.type === 'info') {
                let auditBpNodeList = result.data || [];
                //
                callbackFun(auditBpNodeList, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
            if(typeof cancleFunc == 'function') {
                cancleFunc(true, theDlg);
            }
        }
    });
}

import SwbMerchtAuditBpStaffList from './MerchtAuditBpStaffList.vue';

Vue.regist(SwbMerchtAuditBpStaffList);

export function openOaAuditBpStaffDlg(params, callbackFun) {
    let oldSelectStaffList = params['oldSelectStaffList'] || [];
    let theDlg = Vue.$showDialog({
        title: '选择OA审核人',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        template: '<swb-oa-audit-bp-staff-list :oldSelectStaffList="oldSelectStaffList" ref="swb_oa_audit_bp_staff_list"></swb-oa-audit-bp-staff-list>',
        data: {
            oldSelectStaffList: oldSelectStaffList
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_oa_audit_bp_staff_list.getDlgResult() || {};
            if(result.type === 'info') {
                let auditBpStaffList = result.data || [];
                callbackFun(auditBpStaffList, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import AuditBpRecsList from './AuditBpRecsList.vue';

Vue.regist(AuditBpRecsList);

export function openOaAuditRecDlg(bizTypeCode, auditSeqNo, bizVoucherNo) {
    Vue.$showDialog({
        title: '审核记录',
        width: '80%',
        height: 600,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-oa-audit-rec-list :bizTypeCode = "bizTypeCode" :bizVoucherNo = "bizVoucherNo" :auditSeqNo="auditSeqNo" ref="swb_oa_audit_rec_list"></swb-oa-audit-rec-list>',
        data: {
            bizTypeCode: bizTypeCode,
            bizVoucherNo: bizVoucherNo,
            auditSeqNo: auditSeqNo,
        }
    });
}

import SwbDingDingAuditView from './DingDingAuditView.vue';

Vue.regist(SwbDingDingAuditView);

export function openDingdingAuditViewDlg(params, callbackFun, cancleFunc) {
    let bizVoucherId = params['bizVoucherId'] || null;
    let bizVoucherNo = params['bizVoucherNo'] || null;
    let bizTypeCode = params['bizTypeCode'] || null;
    if(Utils.isNoB(bizTypeCode)) {
        MsgBox.warning('业务类型不可为空！');
        return;
    }
    let theDlg = Vue.$showDialog({
        title: '钉钉审批预览页面',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        template: '<swb-ding-ding-audit-view :bizVoucherId="bizVoucherId" :bizVoucherNo="bizVoucherNo" :bizTypeCode="bizTypeCode" ref="swb_ding_ding_audit_view"></swb-ding-ding-audit-view>',
        data: {
            bizVoucherId: bizVoucherId,
            bizVoucherNo: bizVoucherNo,
            bizTypeCode: bizTypeCode,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_ding_ding_audit_view.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data || [];
                callbackFun(data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        cancelClicked: function () {
            if(typeof cancleFunc == 'function') {
                cancleFunc(theDlg);
            }
        }
    });
}

import SwbFeiShuAuditView from './FeiShuAuditView.vue';

Vue.regist(SwbFeiShuAuditView);

export function openFeiShuAuditViewDlg(params, callbackFun, cancleFunc) {
    let bizVoucherId = params['bizVoucherId'] || null;
    let bizVoucherNo = params['bizVoucherNo'] || null;
    let bizTypeCode = params['bizTypeCode'] || null;
    if(Utils.isNoB(bizTypeCode)) {
        MsgBox.warning('业务类型不可为空！');
        return;
    }
    let self = this;
    let theDlg = Vue.$showDialog({
        title: '飞书审批预览页面',
        width: 700,
        height: 500,
        showCloseBtn: true,
        template: '<swb-fei-shu-audit-view :bizVoucherId="bizVoucherId" :bizVoucherNo="bizVoucherNo" :bizTypeCode="bizTypeCode" ref="swb_fei_shu_audit_view"></swb-fei-shu-audit-view>',
        data: {
            bizVoucherId: bizVoucherId,
            bizVoucherNo: bizVoucherNo,
            bizTypeCode: bizTypeCode,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_fei_shu_audit_view.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data || [];
                this.$confirm('请确认审批流程是否正确？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    callbackFun(data, theDlg);
                    //
                    theDlg.close();
                }).catch(function () {
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
            if(typeof cancleFunc == 'function') {
                cancleFunc(theDlg);
            }
        }
    });
}

import SwbAuditType from './AuditType';
import merchtComnApi from '../../api/merchtComn';

Vue.regist(SwbAuditType);

export function openAuditTypeDlg(bizType, callbackFun) {
    let theDlg = Vue.$showDialog({
        title: '审批方式',
        width: 500,
        height: 300,
        showCloseBtn: true,
        template: '<swb-audit-type :bizType="bizType" ref="swb_audit_type"></swb-audit-type>',
        data: {
            bizType: bizType
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_audit_type.getDlgResult() || {};
            if(result.type === 'info') {
                let data = result.data || {};
                callbackFun(data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/oaAudit/selectDlg.js
// module id = 58
// module chunks = 0